module.exports = __webpack_public_path__ + "static/patternspage-e80dd967fecfd5a0e736142a5b0d362b.png";